import * as React from 'react';
import * as moment from 'moment';

const AnalyticsTooltip = ({ active, payload, tooltipValueLabel, formatter }) => {
  const [current, old] = ((payload && payload.reverse()) || []);

  if (active && (current || old)) {
    return (
      <div className="Graph__Tooltip">
        {current && (
          <>
            <div className="Graph__Tooltip__Label">{moment(current.payload.date).format('MMMM D, YYYY')}</div>
            <div className="Graph__Tooltip__Row">
              <div className="Graph__Tooltip__Row__Stroke" style={{ backgroundColor: current.stroke }} />
              <div className="Graph__Tooltip__Row__Name">{tooltipValueLabel}</div>
              {formatter ? formatter(current.payload[current.dataKey]) : current.payload[current.dataKey]}
            </div>
          </>
        )}
        {old && (
          <>
            <div className="Graph__Tooltip__Label">{moment(old.payload.old_date).format('MMMM D, YYYY')}</div>
            <div className="Graph__Tooltip__Row">
              <div className="Graph__Tooltip__Row__Stroke" style={{ backgroundColor: old.stroke }} />
              <div className="Graph__Tooltip__Row__Name">{tooltipValueLabel}</div>
              {formatter ? formatter(old.payload[old.dataKey]) : old.payload[old.dataKey]}
            </div>
          </>
        )}
      </div>
    );
  }

  return null;
};

export default AnalyticsTooltip;
